export default __webpack_public_path__ + "static/media/Graphics_LINKED-IN-COVER-update-05-min.23974a28.jpg";